import { useCallback } from 'react'

import { useAppContext } from 'contexts/app-context/hooks'
import { useNavigator } from 'common/hooks/useNavigator'
import { leaveCentralDePrivacidade, logBridgeError, sendSelectContent } from 'common'
import { Routes } from 'common/constants'
import { useLocation } from 'react-router-dom'

import { TUseHeaderProps, TUseHeaderReturn } from '../types/useHeader.types'

const useHeader = ({
  goToPath,
  ticScreen,
  homeIconRoute,
  leaveToApp,
  isHome,
}: TUseHeaderProps): TUseHeaderReturn => {
  const { userCountry, userAccountType, isQuickLoad } = useAppContext()
  const { pathname } = useLocation()

  const { navigateBack, goTo: navigateTo } = useNavigator()

  const shouldExitApp = (isQuickLoad && isHome) || leaveToApp

  const onReturnClickHandler = useCallback(async () => {
    if (userCountry && userAccountType) {
      try {
        await sendSelectContent({
          flow: 'header',
          step: ticScreen ?? '-',
          screen_name: pathname as Routes,
          element_name: 'header_click',
          element_type: 'button',
          parent_name: 'header',
          scenario: JSON.stringify({
            screen: ticScreen ?? '-',
            userAccountType,
            userCountry,
          }),
        })
      } catch (error: unknown) {
        logBridgeError('send header return tic', error)
      }
    }
    if (shouldExitApp) {
      leaveCentralDePrivacidade()
    } else goToPath ? navigateTo(goToPath) : navigateBack()
  }, [
    userCountry,
    userAccountType,
    goToPath,
    navigateTo,
    navigateBack,
    ticScreen,
    shouldExitApp,
    pathname,
  ])

  return {
    onReturnClickHandler,
    goTo: (route: string) => {
      if (homeIconRoute) {
        navigateTo(homeIconRoute)
      } else {
        navigateTo(route)
      }
    },
  }
}

export { useHeader }
